import SearchBox from "../../common_nextgen/common_components/SearchScreenComponents/SearchBox";
import DisplayTable from "../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";
import ButtonsSection from "../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";
import ConfirmationModal from "../../common_nextgen/common_components/Modal/ConfirmationModal";
import useAccumulatorOverrideSchedule from "./hooks/useAccumulatorOverrideSchedule";

const AccumulatorOverrideSchedule = ({
  onSelect,
  hideModal,
  params,
  selectMode,
  lookupType,
  selectModeParamData,
}) => {
  const accumulatorOverrideScheduleData = useAccumulatorOverrideSchedule(
    onSelect,
    hideModal,
    params,
    selectMode,
    lookupType,
    selectModeParamData
  );

  return (
    <div class="container container-fluid">
      <ButtonsSection
        ctaButtons={accumulatorOverrideScheduleData.leftButtons}
        align="left"
      />
      <div className="header-section">
        <h1>
          {accumulatorOverrideScheduleData.screen_title} -{" "}
          <span className="heading-cod">
            {accumulatorOverrideScheduleData.screenNumber}
          </span>
        </h1>
      </div>
      <SearchBox
        formFields={accumulatorOverrideScheduleData.formFields}
        dropdownValues={accumulatorOverrideScheduleData.dropdownValues}
        paramsData={accumulatorOverrideScheduleData.paramsData}
        updataParamData={accumulatorOverrideScheduleData.updateParamData}
        disabledDropdowns={accumulatorOverrideScheduleData.disabledDropdowns}
      />
      <ButtonsSection ctaButtons={accumulatorOverrideScheduleData.ctaButtons} />
      <DisplayTable
        selectMode={accumulatorOverrideScheduleData.selectMode}
        data={accumulatorOverrideScheduleData.data}
        parmKey={accumulatorOverrideScheduleData.parmKey}
        menuOptions={accumulatorOverrideScheduleData.menuOptions}
        tableHeaders={accumulatorOverrideScheduleData.columnDef}
        setRowData={accumulatorOverrideScheduleData.setRowData}
        selectedPriceSchedules={accumulatorOverrideScheduleData.selectedRows}
        setSelectedPriceSchedules={
          accumulatorOverrideScheduleData.setSelectedRows
        }
      />
      <div className="paginator-container">
        <NextGenPaginator
          first={accumulatorOverrideScheduleData.first}
          rows={accumulatorOverrideScheduleData.rows}
          totalRecords={accumulatorOverrideScheduleData.totalRecords}
          currentPage={accumulatorOverrideScheduleData.currentPage}
          rowsPerPageOptions={[10, 25, 50]}
          onPageChange={accumulatorOverrideScheduleData.onPageChange}
        />
      </div>
      {accumulatorOverrideScheduleData.isConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={accumulatorOverrideScheduleData.isConfirmationModalOpen}
          onRequestClose={
            accumulatorOverrideScheduleData.closeConfirmationModal
          }
          onBack={accumulatorOverrideScheduleData.closeConfirmationModal}
          onSave={
            accumulatorOverrideScheduleData.deleteAccumulatorOverrideSchedule
          }
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={accumulatorOverrideScheduleData.setSelectedOption}
        />
      )}
      {accumulatorOverrideScheduleData.isHideConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={accumulatorOverrideScheduleData.isHideConfirmationModalOpen}
          onRequestClose={
            accumulatorOverrideScheduleData.closeHideConfirmationModal
          }
          onBack={accumulatorOverrideScheduleData.closeHideConfirmationModal}
          onSave={accumulatorOverrideScheduleData.hideSchedule}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={
            accumulatorOverrideScheduleData.setHideSelectedOption
          }
        />
      )}
    </div>
  );
};

export default AccumulatorOverrideSchedule;
